import AdminAgreementsPage from './AdminAgreementsPage';

export default AdminAgreementsPage;
